function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.667 0A3.333 3.333 0 0120 3.333v13.334A3.333 3.333 0 0116.667 20H3.333A3.333 3.333 0 010 16.667V3.333A3.333 3.333 0 013.333 0h13.334zm-.163 2H3.496C2.67 2 2 2.67 2 3.496v13.008C2 17.33 2.67 18 3.496 18h13.008C17.33 18 18 17.33 18 16.504V3.496C18 2.67 17.33 2 16.504 2zM10 5a1 1 0 011 1v2.999L14 9a1 1 0 010 2h-3v3a1 1 0 01-2 0v-3H6a1 1 0 010-2h3V6a1 1 0 011-1z"
}));